import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";

import type { DatasetDTO } from "../../../types/Dataset";
import type { RootState } from "../../store";

interface SelectedDatasetState {
  dataset?: DatasetDTO | undefined;
}

export const selectDataset = createSelector(
  (state: RootState) => state,
  (state) => state.selectedDataset,
);

export const selectedDatasetSlice = createSlice({
  name: "dataset",
  initialState: { dataset: undefined } as SelectedDatasetState,
  reducers: {
    updateSelectedDataset: (state, action: PayloadAction<DatasetDTO>) => {
      state.dataset = action.payload;
    },
    //TODO: use combineReducers to clear dataset and field states in one action
    clearSelectedDataset: (state) => {
      state.dataset = undefined;
    },
  },
});

export const { updateSelectedDataset, clearSelectedDataset } =
  selectedDatasetSlice.actions;
